function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSettingsSites = function SvgSettingsSites(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,30.5a4.5,4.5,0,0,1,9,0c0,1.81-.63,2.32-4,7.26a.56.56,0,0,1-.92,0C20.63,32.82,20,32.31,20,30.5Zm6.38,0a1.88,1.88,0,1,0-1.88,1.87A1.88,1.88,0,0,0,26.38,30.5Z",
    style: {
      fill: "#666"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,22.5a4.5,4.5,0,0,1,9,0c0,1.81-.63,2.32-4,7.26a.56.56,0,0,1-.92,0C30.63,24.82,30,24.31,30,22.5Zm6.38,0a1.88,1.88,0,1,0-1.88,1.87A1.88,1.88,0,0,0,36.38,22.5Z",
    style: {
      fill: "#666"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,23.5a4.5,4.5,0,0,1,9,0c0,1.81-.63,2.32-4,7.26a.56.56,0,0,1-.92,0C11.63,25.82,11,25.31,11,23.5Zm6.38,0a1.88,1.88,0,1,0-1.88,1.87A1.88,1.88,0,0,0,17.38,23.5Z",
    style: {
      fill: "#666"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,16.5a4.5,4.5,0,0,1,9,0c0,1.81-.63,2.32-4,7.26a.56.56,0,0,1-.92,0C22.63,18.82,22,18.31,22,16.5Zm6.38,0a1.88,1.88,0,1,0-1.88,1.87A1.88,1.88,0,0,0,28.38,16.5Z",
    style: {
      fill: "#666"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsSites, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings-sites.4ef3460e.svg";
export { ForwardRef as ReactComponent };